import { nestApiClient } from './api-client';
import {
  CurrencyResponse,
  RedeemCouponResponse,
  StockResponse,
  ConsolidatedOffersResponse,
  SegmentedOffersResponse,
  CategoryType,
  OfferByIdResponse,
  ActiveDripOffer,
  ConsolidatedOffersQuery,
} from '@wwe-portal/entities/offer.type';

export const getSegmentedOffers = () => {
  return nestApiClient.get<SegmentedOffersResponse>('/v1/segmented-offers');
};

export const getSegmentedOffersForNonLogin = () => {
  return nestApiClient.get<SegmentedOffersResponse>(
    '/v1/segmented-offers/non-login'
  );
};

export const getConsolidatedOffers = (categories?: CategoryType[]) => {
  const params: ConsolidatedOffersQuery = {};
  if (categories) {
    params.categories = categories.join(',');
  }
  return nestApiClient.get<ConsolidatedOffersResponse>('/offers/v3/segmented', {
    params,
  });
};

export const getOfferById = (offerId: string) => {
  return nestApiClient.get<OfferByIdResponse>(`/offers/v2/${offerId}`);
};

export const getOfferStocks = () => {
  return nestApiClient.get<StockResponse>(`/offers/v2/stocks/all`);
};

export const postCoupon = ({ couponId }: { couponId: string }) => {
  return nestApiClient.post<RedeemCouponResponse>('/coupon/v2', {
    couponId,
  });
};

export const checkOfferValiditiy = (offerId: string) => {
  return nestApiClient.get<{ data: { success: boolean; message: string } }>(
    `/offers/v2/${offerId}/check`
  );
};

export const getActiveDripOffers = () => {
  return nestApiClient.get<{
    data: { success: boolean; data: ActiveDripOffer[] };
  }>('/offers/v2/drip/active');
};

export const getCurrencies = () => {
  return nestApiClient.get<CurrencyResponse>('/offers/v2/currency');
};

export const dismissOtoOffer = (offerId: string) => {
  return nestApiClient.post<{ data: { success: boolean } }>(
    '/offers/v2/dismiss-oto-ssl',
    { offerId }
  );
};
